import React, { Component } from "react";
import { Router } from "react-router-dom";

import browserHistory from "./RouterHistory";
import RouterUtils from "./RouterUtils";
import Switch from "./DefaultSwitch";

import TechnicalPageRouter from "../TechnicalPage/TechnicalPageRouter";
import ProjectRouter from "../Pages/Project/ProjectRouter";
import Home from "../Pages/Home/Home";
import UserConsent from "../Pages/User/UserConsent";
import AuthorizeRouterApi from "../ApiAuthorization/AuthorizeRouterApi";
import { ApplicationPaths } from "../ApiAuthorization/ApiAuthorizationConstants";

class BaseRouter extends Component {

  render() {
    let routes = [
      {
        path: "/",
        component: Home,
        exact: true,
        isAuthProtected: true,
      },
      {
        path: "/terms",
        component: UserConsent,
        exact: true,
        isAuthProtected: true,
      },
      {
        path: "/tech",
        component: TechnicalPageRouter,
      },
      {
        path: ApplicationPaths.ApiAuthorizationPrefix,
        component: AuthorizeRouterApi,
      },
      ...ProjectRouter,
    ];

    return (
      <Router history={browserHistory} forceRefresh={false}>
        <Switch>
          {RouterUtils.makeRoutes(routes)}
        </Switch>
      </Router>
    );
  }
}

export default BaseRouter;
